import { updateUser } from "../integrations/APIClient";

const GOOGLE_AUTH_PENDING_KEY = "chesshood.googleAuth.pending";
const GOOGLE_AUTH_REDIRECT_KEY = "chesshood.googleAuth.redirectTo";

function getSessionStorage() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export async function syncBackendUser(signedInUser, overrides = {}) {
  const idToken = await signedInUser.getIdToken();
  const fallbackUsername =
    signedInUser.displayName ||
    signedInUser.email?.split("@")[0] ||
    overrides.username ||
    "user";

  const normalizedFullName = (
    overrides.fullName ||
    signedInUser.displayName ||
    ""
  ).trim();

  const payload = {
    token: idToken,
    email: signedInUser.email,
    username: (overrides.username || fallbackUsername).trim(),
    chessLevel: overrides.chessLevel ?? 0,
  };

  if (normalizedFullName) {
    payload.fullName = normalizedFullName;
  }

  await updateUser(payload);
}

export function storePendingGoogleAuth(redirectTo) {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.setItem(GOOGLE_AUTH_PENDING_KEY, "1");

  if (redirectTo) {
    storage.setItem(GOOGLE_AUTH_REDIRECT_KEY, redirectTo);
    return;
  }

  storage.removeItem(GOOGLE_AUTH_REDIRECT_KEY);
}

export function readPendingGoogleAuth() {
  const storage = getSessionStorage();
  if (!storage || storage.getItem(GOOGLE_AUTH_PENDING_KEY) !== "1") {
    return null;
  }

  return {
    redirectTo: storage.getItem(GOOGLE_AUTH_REDIRECT_KEY) || null,
  };
}

export function clearPendingGoogleAuth() {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(GOOGLE_AUTH_PENDING_KEY);
  storage.removeItem(GOOGLE_AUTH_REDIRECT_KEY);
}

export function shouldUseGoogleRedirectFallback(error) {
  const code = error?.code || "";

  return [
    "auth/popup-blocked",
    "auth/popup-closed-by-user",
    "auth/cancelled-popup-request",
    "auth/operation-not-supported-in-this-environment",
  ].includes(code);
}

export function formatAuthError(error, fallbackMessage = "Authentication failed.") {
  switch (error?.code) {
    case "auth/unauthorized-domain":
      return "This domain is not enabled for Google sign-in in Firebase Auth.";
    case "auth/network-request-failed":
      return "Network error. Please check your connection and try again.";
    case "auth/popup-closed-by-user":
      return "The Google sign-in window was closed before login finished.";
    default:
      return error?.message || fallbackMessage;
  }
}
